var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLightmodeSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 37C74 16.5655 57.4345 0 37 0C16.5655 0 0 16.5655 0 37C0 57.4345 16.5655 74 37 74C57.4345 74 74 57.4345 74 37Z",
    fill: "#48214C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9688 34.9604C33.2825 35.5323 32.9775 36.2185 32.9775 37.1716C32.9775 38.1247 33.3588 38.7347 34.1975 39.2685C34.8838 39.726 36.7519 40.5266 41.5937 41.7085C41.67 41.7085 41.7081 41.7085 41.7462 41.7466V34.7698C40.2212 34.2742 38.6581 34.0454 37.0569 34.0454C35.7225 34.0454 34.6932 34.3504 33.9688 34.9223V34.9604Z",
    fill: "#E1B34B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7465 51.3922V43.8054C41.5177 43.7673 41.3271 43.691 41.0983 43.6148C36.9428 42.5854 34.3122 41.7085 33.0922 40.9079C32.7872 40.7173 32.4822 40.4504 32.2534 40.2217V48.4947C33.5878 48.9522 35.0746 49.3716 36.6759 49.791C38.849 50.3247 40.4883 50.8585 41.7083 51.3922H41.7465Z",
    fill: "#E1B34B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9478 26.4963C32.1384 26.992 32.2528 27.5257 32.2528 28.0595V33.8544C32.2528 33.8544 32.5577 33.5494 32.7102 33.435C33.7777 32.5582 35.2646 32.1007 37.0565 32.1007C38.6196 32.1007 40.1827 32.3294 41.7458 32.7488V28.0595C41.7458 27.4113 41.8983 26.8013 42.1652 26.2676C40.5639 25.9626 38.9627 25.772 37.3615 25.772C35.4171 25.772 33.5871 26.0007 31.9478 26.4963Z",
    fill: "#E1B34B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3709 58.2548H37.629C39.8784 58.2548 41.7465 56.4248 41.7465 54.1374V53.6036C40.9458 53.1461 39.3446 52.498 36.2184 51.7355C34.8078 51.3924 33.4734 51.0111 32.2534 50.6299V54.1374C32.2534 56.3867 34.0834 58.2548 36.3709 58.2548Z",
    fill: "#E1B34B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3225 23.98H28.135C29.0881 23.98 29.965 24.285 30.6512 24.8569C32.6718 24.1707 34.9212 23.8275 37.3612 23.8275C39.458 23.8275 41.5549 24.0944 43.6899 24.59C44.2999 24.2088 45.0624 23.98 45.863 23.98H49.6755C51.9248 23.98 53.7929 22.1501 53.7929 19.8626C53.7929 17.6132 51.9629 15.7451 49.6755 15.7451H24.3225C22.0732 15.7451 20.2051 17.5751 20.2051 19.8626C20.2051 22.1119 22.0351 23.98 24.3225 23.98Z",
    fill: "#E1B34B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightmodeSvg);
export default __webpack_public_path__ + "static/media/logo-lightmode-svg.2cf52296865eafaf6e5df9bd3855434e.svg";
export { ForwardRef as ReactComponent };